export const user = {
  avatar: `/assets/avatars/avatar_pic.png`,
  location: "USA",
  jobTitle: "Senior Developer",
  firstName: "John",
  lastName: "Doe",
  middleName: "",
  email: "john@gmail.com"
};

export const states = [
  {
    value: "full-acces",
    label: "Full Access",
  },
  {
    value: "service-desk-module",
    label: "Service Desk Module",
  },
];
